<div class="modal-header">
    <h4 class="modal-title">{{ review.product.productName }}</h4>
    <button type="button" class="close" (click)="activeModal.close()">
        <span>×</span>
    </button>
</div>
<div class="modal-body p-0">
    <div class="nickname">
        {{ review.nickname }}
    </div>
    <div class="rate">
        {{ review.rate }}
    </div>
    <div class="review">
        {{ review.review }}
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-sm btn-secondary" (click)="activeModal.close()">Close</button>
</div>
